import RevokedBanner from './RevokedBanner'
export default RevokedBanner
